import React, { useState, useEffect } from 'react';
import { Button, PageHeader } from 'components';
import { Form, Input, Row, Col, Upload, Image } from 'antd';
import { CheckOutlined, InboxOutlined } from '@ant-design/icons';
import styles from './style.module.scss';
import { useTranslation } from 'react-i18next';
import useShoppingCenter from '../useShoppingCenter';
import FormHelper from 'helpers/FormHelper';
import { Descriptions } from 'antd';

const ShoppingCenterEdit = ({ isNew }) => {
  const { t } = useTranslation();
  const { singleShop, handleCreateOrUpdateShop, form, updateInProcess } =
    useShoppingCenter(false);
  const [selectedShoppingCenter, setSelectedShoppingCenter] = useState(null);
  
  const onFinish = async (values) => {
    await handleCreateOrUpdateShop(values);
  };

  const getAvailableLanguages = () => {
    if (!selectedShoppingCenter) return ['IT', 'EN'];

    const isSOV = selectedShoppingCenter.title?.toLowerCase().includes('sov') ||
                  selectedShoppingCenter.name?.toLowerCase().includes('sov') ||
                  selectedShoppingCenter.prefix?.toLowerCase().includes('sov');
    
    return isSOV ? ['IT', 'EN'] : ['IT', 'EN', 'FR'];
  };
  
  const availableLanguages = getAvailableLanguages();


  useEffect(() => {
    if (singleShop) {
      setSelectedShoppingCenter(singleShop);
    }
  }, [singleShop]);

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const title = isNew
    ? t('CREARE OUTLET VILLAGE')
    : t('MODIFICA OUTLET VILLAGE');

  const handleCreate = () => {
    form.submit();
  };

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label={t('Titolo')} name='title'>
                <Input loading={true} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label={t('Loyalty url')} name='loyalty_url'>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label={t('Prefix')} name='prefix'>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label={t('Mappa extrastock')}>
                <Image src={singleShop.extrastock_map} className={styles.map} />
                <Form.Item
                  name='extrastock_map'
                  multiple={false}
                  valuePropName='fileList'
                  getValueFromEvent={FormHelper.normFile}
                  noStyle
                >
                  <Upload.Dragger
                    multiple={false}
                    name='file'
                    beforeUpload={FormHelper.beforeUpload}
                    accept='image/jpeg,image/png,image/svg+xml'
                  >
                    <p className='ant-upload-drag-icon'>
                      <InboxOutlined />
                    </p>
                    <p className='ant-upload-text'>
                      {t('Click or drag file to this area to upload1')}
                      'JPG', 'PNG', 'SVG'
                      {t('Click or drag file to this area to upload2')}
                    </p>
                  </Upload.Dragger>
                </Form.Item>
                <Descriptions column={1} bordered>
                    <Descriptions.Item label={`${t('Formati accettati')}:`}>
                    JPG PNG SVG
                    </Descriptions.Item>
                    <Descriptions.Item label={`${t('Dimensione massima')}:`}>
                    3MB
                    </Descriptions.Item>
                  </Descriptions>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label={t('Privacy Career - uso candidati')}
                name='privacy_candidate'
              >
                <Input.TextArea placeholder={t('Inserisci testo')} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={t('Privacy Career - uso tenants')}
                name='privacy_company'
              >
                <Input.TextArea placeholder={t('Inserisci testo')} />
              </Form.Item>
            </Col>
          </Row>

          {/*<Row gutter={24}>*/}
          {/*  <Col span={12}>*/}
          {/*    <Form.Item*/}
          {/*      label={t('Telegram connector academy food')}*/}
          {/*      name='tg_academy_food'*/}
          {/*    >*/}
          {/*      <Input placeholder={t('Inserisci testo')} />*/}
          {/*    </Form.Item>*/}
          {/*  </Col>*/}
          {/*  <Col span={12}>*/}
          {/*    <Form.Item*/}
          {/*      label={t('Telegram connector academy retail')}*/}
          {/*      name='tg_academy_retail'*/}
          {/*    >*/}
          {/*      <Input placeholder={t('Inserisci testo')} />*/}
          {/*    </Form.Item>*/}
          {/*  </Col>*/}
          {/*</Row>*/}
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item label={t('Smart shopping path')} name='cc_path'>
                <Input placeholder={t('Inserisci testo')} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={t('Smart shopping auth path')}
                name='cc_auth_path'
              >
                <Input placeholder={t('Inserisci testo')} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label={t('Smart shopping token')} name='cc_token'>
                <Input placeholder={t('Inserisci testo')} />
              </Form.Item>
            </Col>
          </Row>
          
          {/* Working Hours - Language Fields */}
          <Row gutter={24}>
            <Col span={availableLanguages.length === 3 ? 8 : 12}>
              <Form.Item label={`${t('Orari di Lavoro')} IT`} name='working_hours_it'>
                <Input placeholder={t('Inserisci orari di lavoro')} />
              </Form.Item>
            </Col>
            <Col span={availableLanguages.length === 3 ? 8 : 12}>
              <Form.Item label={`${t('Orari di Lavoro')} EN`} name='working_hours_en'>
                <Input placeholder={t('Inserisci orari di lavoro')} />
              </Form.Item>
            </Col>
            {availableLanguages.includes('FR') && (
              <Col span={8}>
                <Form.Item label={`${t('Orari di Lavoro')} FR`} name='working_hours_fr'>
                  <Input placeholder={t('Inserisci orari di lavoro')} />
                </Form.Item>
              </Col>
            )}
          </Row>
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={handleCreate}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={updateInProcess}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ShoppingCenterEdit;
